module.exports = __webpack_public_path__ + "static/img/air-product5.a17ad31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/air-product5.png
// module id = N50Q
// module chunks = 1